import { ReactElement } from 'react';

interface Props {
  className?: string;
}

function logout({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="black"
      width="24"
      height="24"
      className={className}
    >
      <path
        stroke="none"
        d="M2 12l-.78-.625-.5.625.5.625L2 12zm9 1a1 1 0 100-2v2zM5.22 6.375l-4 5 1.56 1.25 4-5-1.56-1.25zm-4 6.25l4 5 1.56-1.25-4-5-1.56 1.25zM2 13h9v-2H2v2zM13.342 20.557l.165-.986-.165.986zm7.597.19l.646.764-.646-.763zM15.014 3.165l-.165-.986.165.986zm5.925.088l.646-.763-.646.763zM13.507 4.43l1.671-.278-.329-1.973-1.671.279.329 1.972zM21 9.083v5.834h2V9.083h-2zm-5.822 10.766l-1.671-.278-.329 1.973 1.671.278.329-1.973zM11 8.132v-.743H9v.743h2zm0 8.48v-.546H9v.546h2zm2.507 2.959c-.824-.138-1.35-.227-1.734-.342-.358-.106-.472-.201-.536-.277l-1.526 1.293c.41.484.932.735 1.491.901.532.159 1.203.269 1.976.398l.329-1.973zM9 16.61c0 .784-.002 1.464.067 2.015.072.578.234 1.135.644 1.619l1.526-1.293c-.064-.075-.14-.203-.185-.574-.05-.398-.052-.932-.052-1.767H9zm12-1.694c0 1.675-.002 2.823-.123 3.67-.116.82-.32 1.174-.584 1.398l1.293 1.526c.797-.675 1.123-1.593 1.272-2.642.144-1.021.142-2.338.142-3.952h-2zm-6.15 6.905c1.59.265 2.89.484 3.92.51 1.06.025 2.018-.146 2.816-.821l-1.293-1.526c-.264.223-.646.367-1.474.347-.856-.021-1.99-.207-3.641-.483l-.329 1.973zm.328-17.671c1.652-.275 2.785-.462 3.64-.483.829-.02 1.21.124 1.475.347l1.293-1.526c-.797-.675-1.757-.846-2.816-.82-1.03.025-2.33.244-3.92.509l.328 1.973zM23 9.083c0-1.614.002-2.93-.142-3.952-.15-1.049-.476-1.967-1.273-2.642l-1.292 1.526c.264.224.468.577.584 1.397.12.848.123 1.996.123 3.67h2zm-9.822-6.626c-.773.128-1.444.238-1.976.397-.559.166-1.081.417-1.491.901l1.526 1.293c.064-.076.178-.17.536-.277.384-.115.91-.204 1.734-.342l-.329-1.972zM11 7.389c0-.835.002-1.369.052-1.767.046-.37.121-.499.185-.574L9.711 3.755c-.41.484-.572 1.04-.644 1.62C8.998 5.924 9 6.604 9 7.388h2z"
      />
    </svg>
  );
}

export default logout;
